import { create } from 'zustand';

interface IQRCodesStore {
    search: string;
    setSearch: (search: string) => void;
    page: number;
    setPage: (page: number) => void;
    lastPage: number;
    setLastPage: (lastPage: number) => void;
    totalResults: number;
    setTotalResults: (totalResults: number) => void;
}

export const useQRCodesStore = create<IQRCodesStore>((set) => ({
    search: '',
    setSearch: (search) => {
        set({ search, page: 1 }); // Reset to page 1 when search changes
    },
    page: 1,
    setPage: (page) => {
        set({ page });
    },
    lastPage: 1,
    setLastPage: (lastPage) => {
        set({ lastPage });
    },
    totalResults: 20,
    setTotalResults: (totalResults) => {
        set({ totalResults });
    },
}));